// extracted by mini-css-extract-plugin
module.exports = {"header":"tw0lANw7ab_yfGkAW6ZJc","dialog":"_2DqY6F3DmB2BfjoT5u1fa-"};